<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 21C7.03789 21 3 16.9621 3 12C3 7.03789 7.03789 3 12 3C16.9621 3 21 7.03789 21 12C21 16.9621 16.9621 21 12 21ZM12 4.27479C7.73902 4.27479 4.27479 7.73902 4.27479 12C4.27479 16.261 7.73902 19.7252 12 19.7252C16.261 19.7252 19.7252 16.261 19.7252 12C19.7252 7.73902 16.261 4.27479 12 4.27479Z"
      class="fill-primary"
    />
    <path
      d="M11.1747 15.8563C10.9931 15.7001 10.9038 15.4611 10.9038 15.136C10.9038 14.5082 11.2672 14.1927 11.9906 14.1927C12.73 14.1927 13.0997 14.5082 13.0997 15.136C13.0997 15.4611 13.0104 15.7001 12.8288 15.8563C12.6471 16.0124 12.373 16.0889 12.0033 16.0889C11.6305 16.0889 11.3564 16.0124 11.1747 15.8563ZM10.958 7.91116H13.0519L12.8288 13.2302H11.2098L10.958 7.91116Z"
      class="fill-primary"
    />
  </svg>
</template>
